/*
 * @Author: caiqin.xie
 * @since: 2023-06-08 09:47:44
 * @lastTime: 2023-11-15 14:47:30
 * @LastEditors: caiqin.xie
 * @message: 博客列表
 * @url: www.picoxr.com/cn/blog
 */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Input } from '@arco-design/web-react';
import { IconSearch } from '@arco-design/web-react/icon';
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import styles from "./index.module.scss";
import Banner from "./components/Banner"
import Pagination from "@/components/Pagination";
import LeftList from "./components/LeftList";
import NewestProduct from "./components/NewestProduct";
import PopularBlog from "./components/PopularBlog";
import SocialPlatform from "./components/SocialPlatform";
import { useDevice } from '@/hooks'
import request from '@/common/request'
import { DOMAIN_API, BLOGTYPE, COUNTRY_HREFLANG, COUNTRY_LIST, BLOGLISTPOS, BLOGLISTPOS2, BLOGLISTPOS3 } from '@/common/const'
import { getUrlData } from '@/common/untils'
import { IBanner, IBlogItem } from '@/common/types'
const _ = require("lodash");

const Blog = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const location = useLocation()
  const query: Record<string, any> = getUrlData(decodeURIComponent(location.search))
  const [keyword, setKeyword] = useState(""); // 搜索关键字
  const [pageNum, setPageNum] = useState<number>(query.page * 1 || 1) // 当前页
  const [pages, setPages] = useState<number>(data?.contentPage.pages * 1) // 总页数
  const [total, setTotal] = useState<number>(data?.contentPage.total * 1) // 总条数
  const [blogList, setBlogList] = useState<IBlogItem[]>(data?.contentPage.records || []) // 博客列表
  const [allBlogList, setAllBlogList] = useState<IBlogItem[]>(data?.contentPage.records || []) // 所有博客
  const bannerLists: IBanner[] = data?.bannerList || [] // banner列表
  const popularList: IBlogItem[] = data?.recommendContentList || [] // 热门博客
  const hostProduct = data?.hostProduct || null // 热门产品
  const newestProduct = data?.newestProduct || null // 最新产品
  const gameBanner: Record<string, any> = data?.bannerList2[0] || null // banner2列表
  const hostBanner: Record<string, any> = data?.bannerList3[0] || null // banner3列表
  const recommendBlogList: IBlogItem[] = data?.recommendBlogList || [] // 推荐博客
  const recommendIds: string[] = data?.recommendIds // 推荐博客id

  // 获取博客列表 (处理pad和移动端分页数据)
  function getBlogList (pageNum: number) {
    request.post(`${DOMAIN_API}/o/content/list`, {
      contentTypeId: BLOGTYPE,
      stationCode: ctry,
      rows: 10,
      page: pageNum,
      recommendIds
    })
    .then(res => {
      const {total, records, pages} = res.data
      setTotal(total * 1)
      setPages(pages * 1)
      setBlogList(records)
      setAllBlogList(allBlogList => _.uniqBy([...allBlogList, ...records], 'id'))
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 分页改变
  const pageChange = (pageNum:number) => {
    setPageNum(pageNum)
    if (device === 'pc') {
      if (pageNum === 1) {
        window.open(`/${ctry}/blog`, '_self')
      } else {
        window.open(`/${ctry}/blog?page=${pageNum}`, '_self')
      }
    } else {
      getBlogList(pageNum)
    }
  }

  // 搜索
  const handleSearch = (e: any) => {
    console.log(keyword)
    window.open(`/${ctry}/blog/search?keyword=${keyword}`, '_self')
  }

  return (
    <div>
      <Helmet>
        <title>{words?.blog_list_title}</title>
        <meta name="description" content={words?.blog_list_description} />
        <meta name="keywords" content={words?.blog_list_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/blog`} />
        {COUNTRY_LIST.map(item => (
          <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/blog`} />
        ))}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['blog-wrap']}>
        {/* banner */}
        <Banner bannerLists={bannerLists}/>
        <div className={styles['blog-content-wrap']}>
          <div className={styles['blog-title']}>
            <h1>{words?.blog_title}</h1>
            {/* PICO blog */}
            {/* 搜索 */}
            <div className={styles['blog-search-wrap']}>
              <Input size="large"
                placeholder={words?.blog_search_placeholder}
                prefix={<IconSearch />}
                value={keyword.trim()}
                onChange={(value: string) => setKeyword(value)}
                onPressEnter={(e) => handleSearch(e)}
              />
              {/* Search */}
            </div>
          </div>
          <div className={styles['blog-content']}>
            {/* 左侧 */}
            <div className={styles['blog-content-left']}>
              {/* 博客列表 */}
              <LeftList
                ctry={ctry}
                words={words}
                device={device}
                pageNum={pageNum}
                blogList={blogList}
                allBlogList={allBlogList}
                recommendBlogList={recommendBlogList}
                hostBanner={hostBanner}
                gameBanner={gameBanner} />

              {/* 分页 */}
              <Pagination
                words={words}
                device={device}
                pageNum={pageNum}
                pages={pages}
                total={total}
                pageChange={pageChange} />
            </div>
            {/* 右侧 */}
            <div className={styles['blog-content-right']}>
              {/* 订阅及最新产品展示 */}
              <NewestProduct ctry={ctry} words={words} newestProduct={newestProduct} />

              {/* 热门博客 */}
              <PopularBlog ctry={ctry} words={words} popularList={popularList} />

              {/* 社交平台 */}
              <SocialPlatform ctry={ctry} words={words} />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit(ctry: string, pathName: string) {
  const decodedUrl = decodeURIComponent(pathName);
  const query = getUrlData(decodedUrl)
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/content/listGather`, {
      contentTypeId: BLOGTYPE,
      stationCode: ctry,
      bannerPositionId: BLOGLISTPOS,
      bannerPositionId2: BLOGLISTPOS2,
      bannerPositionId3: BLOGLISTPOS3,
      page: query.page || 1,
      rows: 10
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

Blog.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default Blog;
